<template>
  <div>
    <div id="player-container" class="video-container"></div>
    <!-- <div id="local_container" class="local"></div> -->
    <img class="play-loading" v-if="isLoading" src="../../assets/images/loading.png" />
  </div>
</template>
<script>
// import Vue from 'vue'
import TRTC from 'trtc-js-sdk'
export default {
  name: 'TRTCLIVE',
  props: ['config', 'muted'],
  data() {
    return {
      isLoading: true,
      // isPlay: false,
      imgPlayBtnUrl: require('@/assets/images/playBtn.png'),
      client: null,
      remoteStream: null,
      // localStream: null,
    }
  },
  watch: {
    config(newData) {
      if (newData) {
        this.init()
      }
    },
    muted(muted) {
      if (!this.remoteStream) {
        return
      }
      this.remoteStream.resume()
      if (muted) {
        this.remoteStream.muteAudio()
      } else {
        this.remoteStream.unmuteAudio()
      }
    },
  },
  created() {},
  mounted() {},
  destroyed() {
    this.leave()
  },
  methods: {
    init() {
      const { sdkAppID, userID, userSig } = this.config
      const client = TRTC.createClient({
        mode: 'rtc',
        sdkAppId: sdkAppID,
        userId: userID,
        userSig: userSig,
      })
      this.client = client
      //创建本地音视频流
      // const localStream = TRTC.createStream({
      //   userId: userID,
      //   audio: true,
      //   video: true,
      // })
      // this.localStream = localStream
      //事件监听
      this.initListener()
      //加入房间
      this.enterRoom()
    },
    initListener() {
      this.client.on('stream-added', event => {
        // console.log('TRTCLIVE', 'stream-added')
        this.$emit('onRemoteRoom', { isStart: true })
        const remoteStream = event.stream
        //订阅远端流
        this.client.subscribe(remoteStream)
      })

      //远端流移除
      this.client.on('stream-removed', event => {
        console.log('TRTCLIVE', 'stream-removed')
        const remoteStream = event.stream
        // console.log(remoteStream)
        this.$emit('onRemoteRoom', { isStart: false })
        // 停止播放并删除相应<video>标签
        remoteStream.stop()
        remoteStream.close()
      })

      this.client.on('stream-subscribed', event => {
        const remoteStream = event.stream
        this.remoteStream = remoteStream
        this.isLoading = false
        this.play()
      })
    },
    async play() {
      try {
        await this.remoteStream.play('player-container', { muted: false })
        this.$emit('onEnterRoom', { msg: 'success', reason: '' })
      } catch (err) {
        // const errCode = err.getCode()
        this.$emit('onEnterRoom', { msg: 'fail', reason: err })
        this.remoteStream.resume()
      }
      this.remoteStream.on('error', error => {
        const errorCode = error.getCode()
        if (errorCode === 0x4043) {
          // PLAY_NOT_ALLOWED,引导用户手势操作并调用 stream.resume 恢复音视频播放
          this.remoteStream.resume()
        }
      })
    },
    async enterRoom() {
      try {
        await this.client.join({ roomId: this.config.roomID, role: 'audience' })
        // this.publishLocalStream()
      } catch (e) {
        console.log(e)
      }
    },
    // publishLocalStream() {
    //   if (this.localStream && this.client) {
    //     this.localStream
    //       .initialize()
    //       .then(() => {
    //         this.localStream.play('local_container')
    //         //发布本地流视频
    //         this.client
    //           .publish(this.localStream)
    //           .catch(error => {
    //             console.error('本地流发布失败' + error)
    //           })
    //           .then(() => {
    //             console.log('本地流发布成功')
    //           })
    //       })
    //       .catch(error => {
    //         console.error('初始化本地流失败' + error)
    //       })
    //   }
    // },
    async leave() {
      //移除音视频标签从HTML页。
      if (this.remoteStream) {
        this.remoteStream.stop()
        this.remoteStream.close()
      }
      try {
        await this.client.leave()
        // this.localStream.stop()
        // this.localStream.close()
        this.$emit('onExitRoom', { msg: 'success', reason: '' })
      } catch (e) {
        this.$emit('onExitRoom', { msg: 'fail', reason: e })
      }
    },
  },
}
</script>
<style lang="less" scoped>
.video-container {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: -1;
}
.local {
  position: absolute;
  top: 20px;
  left: 34px;
  width: 96px;
  height: 130px;
}
.play-button {
  width: 8rem;
  height: 8rem;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -50px;
  margin-top: -50px;
  z-index: 9999;
}
.play-loading {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 6rem;
  height: 6rem;
  margin-left: -3rem;
  margin-top: -3rem;
  z-index: 9999;
  animation: rotateImg 2s linear infinite;
}
.play-btn {
  width: 8rem;
  height: 8rem;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -50px;
  margin-top: -50px;
  z-index: 9999;
}
@keyframes rotateImg {
  0% {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(180deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
